import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Title,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title, Legend);

type HuaweiDailyChartProps = {
  data: any[];
};

const HuaweiDailyChart = ({ data }: HuaweiDailyChartProps) => {
  const labels = data.map((item) => item.collectTime?.slice(0, 10));
  const values = data.map((item) => item.dataItemMap?.day_energy ?? 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Produkcja dzienna (kWh)",
        data: values,
        backgroundColor: "#4A90E2",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" as const },
      title: { display: true, text: "Produkcja dzienna (ostatnie dni)" },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default HuaweiDailyChart;
